// extracted by mini-css-extract-plugin
export default {"idpMenuBar":"MenuBar_idpMenuBar__78zjE"};